/* eslint-disable no-unused-vars */
import React from 'react'
import { useRouter } from 'next/router'
import { Button, Typography } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import CustomModal from 'src/components/base/CustomModal/CustomModal'
import { deactivateIntegration, selectCurrencyToken } from 'src/features'

interface DeleteIntegrationModalProps {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    id: number
}

const DeleteIntegrationModal: React.FC<DeleteIntegrationModalProps> = (props) => {
  const { isModalVisible, setIsModalVisible, id } = props
  const { t } = useTranslation()
  const route = useRouter()
  const dispatch = useAppDispatch()
  const currency_code = useAppSelector(selectCurrencyToken)

  const handleClickDelete = () => {
    dispatch(deactivateIntegration(id, currency_code))
    route.push('/developers')
  }

  return <CustomModal
    width={300}
    footer={null}
    open={isModalVisible}
    onCancel={() => setIsModalVisible(false)}
    title={t('developers.DeleteIntegration')}
  >
    {/* Texts */}
    <Typography.Paragraph className='style-font'>
      {t('developers.DeleteIntegrationDescription')}
    </Typography.Paragraph>

    {/* Buttons */}
    <Button
      block
      size='large'
      type='primary'
      className='radius-100 mb-4'
      onClick={() => setIsModalVisible(false)}
    >{t('developers.KeepIntegration')}
    </Button>

    <Button
      block
      danger
      size='large'
      className='radius-100'
      onClick={handleClickDelete}
    >{t('developers.ConfirmDeleteIntegration')}
    </Button>
  </CustomModal>
}
export default DeleteIntegrationModal
